import type { MutableRefObject } from 'react';
import { datadogLogs } from '@datadog/browser-logs';

export const executeCaptcha = async (
  captchaRef: MutableRefObject<{
    resetCaptcha: () => void;
    execute: (options: { async: boolean }) => Promise<{ response: string }>;
  }>,
) => {
  try {
    captchaRef.current.resetCaptcha();
    const { response: captchaToken } = await captchaRef.current.execute({
      async: true,
    });
    datadogLogs.logger.info(`Captcha executed successfully with token: ${captchaToken}`);
    return captchaToken;
  } catch (error: unknown) {
    datadogLogs.logger.error('Error executing captcha', {}, error as Error);
  }
};
